// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BookRouteImport } from './routes/book'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AppointmentManageRouteImport } from './routes/appointment.manage'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminInvoicesRouteImport } from './routes/admin/invoices'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AppointmentManageRoute = AppointmentManageRouteImport.update({
            id: '/appointment/manage',path: '/appointment/manage',getParentRoute: () => rootRouteImport
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const AdminInvoicesRoute = AdminInvoicesRouteImport.update({
            id: '/admin/invoices',path: '/admin/invoices',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,BookRoute: BookRoute,ContactRoute: ContactRoute,ReviewsRoute: ReviewsRoute,ServicesRoute: ServicesRoute,UnsubscribeRoute: UnsubscribeRoute,AdminInvoicesRoute: AdminInvoicesRoute,AdminLoginRoute: AdminLoginRoute,AdminUsersRoute: AdminUsersRoute,AppointmentManageRoute: AppointmentManageRoute,AdminIndexRoute: AdminIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)